(() => {
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (reduceMotion) return;

  const CONFIG = {
    enabled: true,
    maxDropsPerClick: 6,
    dropSizeMin: 6,
    dropSizeMax: 14,
    fallDistanceMin: 120,
    fallDistanceMax: 240,
    durationMin: 650,
    durationMax: 1100,
    colors: ["#a79929", "#b89f2f", "#8f7a20"]
  };

  const rand = (min, max) => Math.random() * (max - min) + min;
  const pick = (arr) => arr[Math.floor(Math.random() * arr.length)];

  function createDrop(x, y) {
    const drop = document.createElement("span");
    drop.className = "oil-drop";

    const size = rand(CONFIG.dropSizeMin, CONFIG.dropSizeMax);
    const dx = rand(-22, 22);
    const fall = rand(CONFIG.fallDistanceMin, CONFIG.fallDistanceMax);
    const dur = rand(CONFIG.durationMin, CONFIG.durationMax);
    const color = pick(CONFIG.colors);

    drop.style.left = `${x + dx}px`;
    drop.style.top = `${y}px`;
    drop.style.width = `${size}px`;
    drop.style.height = `${size * 1.35}px`;
    drop.style.background = color;
    drop.style.setProperty("--fall", `${fall}px`);
    drop.style.setProperty("--dur", `${dur}ms`);

    document.body.appendChild(drop);
    setTimeout(() => drop.remove(), dur + 150);
  }

  function onClick(e) {
    if (!CONFIG.enabled) return;

    const tag = (e.target && e.target.tagName) ? e.target.tagName.toLowerCase() : "";
    if (["input", "textarea", "select", "label"].includes(tag)) return;

    const drops = Math.floor(rand(3, CONFIG.maxDropsPerClick + 1));
    for (let i = 0; i < drops; i++) createDrop(e.clientX, e.clientY);
  }

  document.addEventListener("click", onClick, { passive: true });
})();